import { useState, useCallback } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Card, Grid } from "@material-ui/core";

import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { DialogAccessLogsUser } from "./DialogAccessLogsUser";
import { columnTextField, columnNumberField } from "utils/tables-utils";

const columnModel = [
  columnTextField(
    {
      dataField: "Login",
      text: "Login",
    },
    false
  ),
  columnTextField(
    {
      dataField: "Nome",
      text: "Usuário",
    },
    false
  ),
  columnTextField(
    {
      dataField: "Sistema",
      text: "Sistema",
      align: "center",
    },
    false
  ),
  columnTextField(
    {
      dataField: "TelaMaisAcessada",
      text: "Tela mais acessada",
    },
    false
  ),
  columnNumberField(
    {
      dataField: "QuantidadeAcesso",
      text: "Quantidade de acessos",
    },
    false
  ),
  columnTextField(
    {
      dataField: "DataHoraUltimoAcesso",
      text: "Data/Hora último acesso",
      align: "center",
    },
    false
  ),
];

const useStyles = makeStyles(componentStyles);

export default function TableAccessLogsUser({
  dataTable,
  totalRegistros,
  currentPage,
  currentSizePerPage,
  searchUsers,
}) {
  const classes = useStyles();

  const [searching, setSearching] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleGetScreenDetail = (data) => {
    setSelectedRow(data);
    setOpenDialog(true);
  };

  const doSearch = useCallback(
    (page, sizePerPage) => {
      setSearching(true);

      searchUsers({}, page, sizePerPage).then(() => setSearching(false));
    },
    [searchUsers]
  );

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  return (
    <Grid item xs={12}>
      <Card classes={{ root: classes.cardRoot }} style={{ display: "flex" }}>
        <ToolkitTable
          searched={Boolean(dataTable)}
          keyField="IdUser"
          dataTable={dataTable}
          columnModel={columnModel}
          headerTitle="Usuários"
          showSearch={false}
          onRowClick={(_, row) => handleGetScreenDetail(row)}
          pagination={{
            options: [25, 50, 100],
            defaultOption: currentSizePerPage,
            totalSize: totalRegistros,
            showTotal: true,
            page: currentPage,
            onPageChange: handlePageChange,
            sizePerPage: currentSizePerPage,
            onSizePerPageChange: handleSizePerPageChange,
          }}
          bootstrapTableProps={{
            remote: true,
            onTableChange: () => {},
          }}
          loading={searching}
          csvFileName={`usuarios_logs.csv`}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado."
        />
      </Card>
      {openDialog && (
        <DialogAccessLogsUser
          open={openDialog}
          data={selectedRow}
          handleClose={() => {
            setOpenDialog(false);
          }}
        />
      )}
    </Grid>
  );
}
